export interface LoginContextOverrides {
  pageName?: string;
  from?: string;
}

interface CapturedPageView {
  routePath: string;
  pageName: string;
}

const PAGE_VIEW_EVENTS = new Set(["UM_Event_PageView", "SK_Event_PageView"]);

let capturedPageView: CapturedPageView | null = null;

const getCurrentRoutePath = (): string => {
  if (typeof window === "undefined") return "/";

  const normalizedPath = window.location.pathname.replace(/\/+$/, "");
  return normalizedPath || "/";
};

const getDefaultPageName = (path: string): string => {
  const cleanPath = path.replace(/^\//, "").split("?")[0].split("#")[0];
  if (!cleanPath) return "home";

  return cleanPath.replace(/\/+/g, "_").replace(/\d+/g, "detail");
};

const getFromByPath = (path: string): string | undefined => {
  if (/^\/(?:[^/]+\/)?in\/news\/[^/]+$/.test(path)) {
    return "From_NewslFollow";
  }

  return undefined;
};

export const capturePageView = (payload: Record<string, unknown>): void => {
  if (!PAGE_VIEW_EVENTS.has(String(payload.eventId))) return;

  const params =
    payload.params && typeof payload.params === "object"
      ? (payload.params as Record<string, unknown>)
      : undefined;
  const pageName = params?.UM_Key_PageName ?? params?.SK_Key_PageName;
  if (typeof pageName !== "string" || !pageName.trim()) return;

  capturedPageView = {
    routePath: getCurrentRoutePath(),
    pageName: pageName.trim(),
  };
};

export const resolveLoginContext = (
  overrides: LoginContextOverrides = {}
): { pageName: string; from?: string } => {
  const routePath = getCurrentRoutePath();
  const capturedPageName =
    capturedPageView?.routePath === routePath
      ? capturedPageView.pageName
      : undefined;
  const from = overrides.from?.trim() || getFromByPath(routePath);

  return {
    pageName:
      overrides.pageName?.trim() ||
      capturedPageName ||
      getDefaultPageName(routePath),
    ...(from ? { from } : {}),
  };
};
